import type { FC } from 'react';

import { useDispatchTrackEventWithLocation } from '../../services/tracking/hooks/useDispatchTrackEventWithLocation';

import { StyledCloseButton } from './styles';

export const CloseExtensionButton: FC = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();
  const handleClickOnClose = () => {
    dispatchTrackEventWithLocation('extension top actions', 'collapse', 'close extension/minimise icon');
    window.parent.postMessage({ message: 'close' }, '*');
  };

  return <StyledCloseButton data-automation="CloseExtensionButton" onClick={handleClickOnClose} variant="flat" />;
};
